import React, { useEffect } from "react";
import AOS from "aos";

// Pages
import LandingPage from "../components/home/LandingPage";
import ThreeScene from "../components/home/ThreeScene";
import HorizontalScroll from "../components/home/HorizontalScroll";
import InfiniteScroll from "../components/home/InfiniteScroll";

// Components
import AboutUs from "../components/AboutUs";
import Technologies from "../components/Technologies";
import EventDetails from "../components/FaceOff/EventDetails";

// Material-UI Components
import { Box, Typography, Grid } from "@mui/material";

function HomePage() {
  const mstc = "Microsoft Student Technical Club 🚀";

  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={7} xl={8}>
          <LandingPage />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={5}
          xl={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: { xs: "50%", sm: "50%", md: "0%", lg: "0%", xl: "0%" },
            left: { xs: "50%", sm: "50%", md: "0%", lg: "0%", xl: "0%" },
            transform: {
              xs: "translate(-50%, -50%)",
              sm: "translate(-50%, -50%)",
              md: "translate(0%, 0%)",
              lg: "translate(0%, 0%)",
              xl: "translate(0%, 0%)",
            },
            zIndex: { xs: -1, sm: -1, md: 0, lg: 0, xl: 0 },
            position: {
              xs: "absolute",
              sm: "absolute",
              md: "relative",
              lg: "relative",
              xl: "relative",
            },
          }}
        >
          <ThreeScene />
        </Grid>
      </Grid>
      <InfiniteScroll data={mstc} />
      <Box sx={{ mt: 10 }}>&nbsp;</Box>
      <Box
        data-aos="fade-up"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          my: 10,
        }}
      >
        <Typography
          fontWeight="bold"
          sx={{
            color: "white",
            fontSize: { xs: 36, sm: 38, md: 50, lg: 52, xl: 58 },
          }}
        >
          Face Off 5.0
        </Typography>
      </Box>
      <EventDetails />
      <Box sx={{ mb: 18 }}>&nbsp;</Box>
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Typography fontWeight="bold" fontSize={100} sx={{ color: "white" }}>
          Events
        </Typography>
      </Box>
      <Box sx={{ overflow: "hidden", my: 4 }}>
        <HorizontalScroll />
      </Box>
      <AboutUs />
      <Technologies />
    </>
  );
}

export default HomePage;
